import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { IHttpUpdateAdminSettingsPayload } from '../../../action/http.action';
import { LinkedinLoginTypeEnum } from '../../../enum/linkedin-login-type.enum';

export const httpUpdateAdminSettings = (type: LinkedinLoginTypeEnum, clientId: string, clientSecret: string) => returnAction<IHttpUpdateAdminSettingsPayload>(ActionEnum.HTTP_UPDATE_ADMIN_SETTINGS, {
  type, clientId, clientSecret
});
